module.exports = __webpack_public_path__ + "img/2.52c4bcbe.jpg";